import $ from 'jquery';

export default class DynamicTestimonial {
  constructor(instance) {
    this.$el = $(instance.el);

    this.slideList = $('.dynamic-testimonials-slides-list', this.$el);
    this.pageList = $('.dynamic-testimonials-pagination-list', this.$el);
    this.$window = $(window);
    this.$navigationItem = $('.dynamic-testimonials-navigation-item a', this.$el);

    const slide = this.slideList.children();
    const count = this.slideList.children().length;

    this.events = [
      $('.dynamic-testimonials-pagination-list-item').on('click.testimonials', (event) => {
        event.preventDefault();
        this.paginate(event);
      }),
      $('.dynamic-testimonials-pagination-item a').on('click.testimonials', (event) => {
        event.preventDefault();
        this.navigate(event);
      }),
      $('.dynamic-testimonials-navigation-item .icon-arrow-right').on('click.testimonials', (event) => {
        event.preventDefault();
        this.navigate(event);
      }),
      $('.dynamic-testimonials-navigation-item .icon-arrow-left').on('click.testimonials', (event) => {
        event.preventDefault();
        this.navigate(event);
      }),
      this.$navigationItem.on('mouseout.testimonials', event => $(event.currentTarget).blur()),
      this.$window.on('resize.testimonials', () => {
        const index = this.slideList.children('.active').attr('data-position');
        this.slideHeight(index);
        this.slideWidth();
        if (count > 1) {
          this.slideAnim(index);
        }
      }),
    ];

    if (count > 1) {
      slide.last().clone().removeAttr('data-position').addClass('cloned')
        .prependTo(this.slideList);
      slide.first().clone().removeAttr('data-position').addClass('cloned')
        .appendTo(this.slideList);
    } else {
      this.slideList.parents('.dynamic-testimonials').addClass('static');
    }

    this.slideHeight(1);
    this.slideWidth();

    if (count > 1) {
      this.slideRotate(1);
    }

    this.slideList.parents('.dynamic-testimonials').addClass('ready');
  }

  slideHeight(index) {
    this.slideList.height(this.slideList.children(`div[data-position='${index}']`).height());
  }

  slideWidth() {
    this.slideList.width(this.slideList.parent().width() * this.slideList.children().length);
    this.slideList.children().width(this.slideList.parent().width());
  }

  slideAnim(index) {
    this.slideList.css({ 'margin-left': -index * this.slideList.parent().width() });
  }

  slideRotate(index) {
    this.slideList.children().removeClass('active');
    this.pageList.children().removeClass('active');
    this.slideList.children(`div[data-position='${index}']`).addClass('active');
    this.pageList.children(`a[data-position='${index}']`).addClass('active');
    this.slideAnim(index);
  }

  paginate(event = false, index = false) {
    if ($(event.currentTarget).hasClass('active') && !index) { return; }

    if (event && !index) {
      index = $(event.currentTarget).attr('data-position');
    }

    this.slideRotate(index);
    this.slideHeight(index);
  }

  navigate(event) {
    let index;
    event.preventDefault();

    const $navigation = $(event.currentTarget).parent('div');

    if ($navigation.hasClass('next-slide')) {
      if (!this.slideList.children('.active').next().hasClass('cloned')) {
        index = this.slideList.children('.active').next().attr('data-position');
      } else {
        index = 1;
      }
    }

    if ($navigation.hasClass('previous-slide')) {
      if (!this.slideList.children('.active').prev().hasClass('cloned')) {
        index = this.slideList.children('.active').prev().attr('data-position');
      } else {
        index = this.slideList.children().length - 2;
      }
    }

    this.slideRotate(index);
    this.slideHeight(index);
  }

  onSectionBlockSelect(block) {
    const index = $(block.el).index();
    this.paginate(false, index);
  }

  onSectionUnload() {
    this.events.forEach($el => $el.off('.testimonials'));
  }
}
